import MuiFormLabel from '@mui/material/FormLabel';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { InfoCircleFilledIcon } from '../icons';

const FormLabel = ({ children, tooltip, ...props }) => {
  return (
    <label>
      <MuiFormLabel component="span" {...props}>
        {children}
      </MuiFormLabel>
      {tooltip && (
        <Tooltip placement="top" title={tooltip}>
          <InfoCircleFilledIcon
            sx={{
              ml: 0.5,
              verticalAlign: 'middle',
              color: 'text.subtle',
              '&:hover': {
                color: 'primary.main',
              },
            }}
          />
        </Tooltip>
      )}
    </label>
  );
};

FormLabel.propTypes = {
  required: PropTypes.bool,
  children: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
};

export default FormLabel;
